import React from "react";
import { createStore } from "@methodjs/store";

interface DisplayModalState {
  open: boolean;
  ModalComponent: JSX.Element;
}

export const DefaultModal = () => {
  return <></>;
};

export const initDisplayModalState = (): DisplayModalState => ({
  open: false,
  ModalComponent: <DefaultModal />,
});

const [useDisplayModalStore, setDisplayModalStore, getDisplayModalStore] =
  createStore(initDisplayModalState);

export { useDisplayModalStore, setDisplayModalStore, getDisplayModalStore };
